export default __webpack_public_path__ + "static/media/crusher-duty.87cbb251.png";